import axios from 'axios'
import * as vars from './vars';

// get all employee by id
export function getEmployee (employeeId, jwt) {
    return axios({
        method: 'GET',
        url: vars.baseURL + '/api/v2/employment/employees/' + employeeId,
        headers: { api_key: vars.apiKey, 'X-XSRF-TOKEN': vars.csrfToken, 'Authorization': `Bearer ${jwt}`},
        data: {}
    })
}

// create new employee
// data = {
//     email: String,
//     firstName: String,
//     lastName: String,
//     userName: String,
//     phone: String,
//     password: String
//     }
export function createEmployee (companyId, data, jwt){
        return axios({
            method: 'POST',
            url: vars.baseURL + '/api/v2/employment/companies/' + companyId + '/employees',
            headers: { api_key: vars.apiKey, 'X-XSRF-TOKEN': vars.csrfToken, 'Authorization': `Bearer ${jwt}`},
            data: data
        })
      }


export function referEmployee (companyId, data, jwt){
      return axios({
          method: 'POST',
          url: vars.baseURL + '/api/v2/employment/companies/' + companyId + '/employees',
          headers: { api_key: vars.apiKey, 'X-XSRF-TOKEN': vars.csrfToken, 'Authorization': `Bearer ${jwt}`},
          data: data
      })
    }

// data = {
// firstName: String,
// lastName: String,
// phone: String,
// photo: String
// }
export function updateEmployee (employeeId, data, jwt){
    return axios({
        method: 'PATCH',
        url: vars.baseURL + `/api/v2/employment/employees/${employeeId}`,
        headers: { api_key: vars.apiKey, 'X-XSRF-TOKEN': vars.csrfToken, 'Authorization': `Bearer ${jwt}`},
        data: data
    })
}

export function logCompanyView (companyId, jwt){
    return axios({
        method: 'POST',
        url: vars.baseURL + `/api/v2/employment/companies/${companyId}/views`,
        headers: { api_key: vars.apiKey, 'X-XSRF-TOKEN': vars.csrfToken, 'Authorization': `Bearer ${jwt}`},
        data: {}
    })
}

// get company
export function getCompany (companyId, jwt) {
    return axios({
        method: 'GET',
        url: vars.baseURL + `/api/v2/employment/companies/${companyId}`,
        headers: { api_key: vars.apiKey, 'X-XSRF-TOKEN': vars.csrfToken, 'Authorization': `Bearer ${jwt}`},
        data: {}
    })
}

export function uploadCompanyMedia (companyId, data, jwt){
    return axios({
        method: 'POST',
        url: vars.baseURL + `/api/v2/employment/companies/${companyId}/media`,
        headers: { api_key: vars.apiKey, 'X-XSRF-TOKEN': vars.csrfToken, 'Authorization': `Bearer ${jwt}`},
        data: data
    })
  }

  export function deleteCompanyMedia (companyId, mediaId, jwt){
    return axios({
        method: 'DELETE',
        url: vars.baseURL + `/api/v2/employment/companies/${companyId}/media/${mediaId}`,
        headers: { api_key: vars.apiKey, 'X-XSRF-TOKEN': vars.csrfToken, 'Authorization': `Bearer ${jwt}`},
        data: {}
    })
  }

// data = {
//     name: String,
//     description: String,
//     message: String,
//     logo: String,
//     mission: String,
//     yearFounded: String,
//     employeeCount: Integer,
//     city: String,
//     state: String,
//     country: String,
//     website: String
//     }
export function updateCompany (companyId, data, jwt) {
    return axios({
        method: 'PATCH',
        url: vars.baseURL + `/api/v2/employment/companies/${companyId}`,
        headers: { api_key: vars.apiKey, 'X-XSRF-TOKEN': vars.csrfToken, 'Authorization': `Bearer ${jwt}`},
        data : data
    })
}

// Returns a list of all the jobs that meet or are close to the criteria.
// data: title, industry, salary, experience
export function getJobs (searchParams, jwt) {
    const params = new URLSearchParams(searchParams)
    return axios({
        method: 'GET',
        url: vars.baseURL + '/api/v2/employment/jobs?' + params,
        headers: { api_key: vars.apiKey, 'X-XSRF-TOKEN': vars.csrfToken, 'Authorization': `Bearer ${jwt}`},
        data: {}
    })
}

export function getJobsPageCount (searchParams, jwt) {
    const params = new URLSearchParams(searchParams)
    return axios({
        method: 'GET',
        url: vars.baseURL + '/api/v2/employment/jobs-page-count?' + params,
        headers: { api_key: vars.apiKey, 'X-XSRF-TOKEN': vars.csrfToken, 'Authorization': `Bearer ${jwt}`},
        data: {}
    })
}

// Returns a list of all the jobs that meet or are close to the criteria.
// data: title, industry, salary, experience
export function getJobsByCompany (companyId, searchParams, jwt) {
    const params = new URLSearchParams(searchParams)
    return axios({
        method: 'GET',
        url: vars.baseURL + `/api/v2/employment/companies/${companyId}/jobs?` + params,
        headers: { api_key: vars.apiKey, 'X-XSRF-TOKEN': vars.csrfToken, 'Authorization': `Bearer ${jwt}`},
        data: {}
    })
}

// Get job by id
export function getJob (jobId, jwt) {
    return axios({
        method: 'GET',
        url: vars.baseURL + `/api/v2/employment/jobs/${jobId}`,
        headers: { api_key: vars.apiKey, 'X-XSRF-TOKEN': vars.csrfToken, 'Authorization': `Bearer ${jwt}`},
        data: {}
    })
}

// Delete job by id
export function deleteJob (jobId, companyId, jwt) {
    const params = new URLSearchParams({companyId:companyId})
    return axios({
        method: 'DELETE',
        url: vars.baseURL + `/api/v2/employment/jobs/${jobId}?` + params,
        headers: { api_key: vars.apiKey, 'X-XSRF-TOKEN': vars.csrfToken, 'Authorization': `Bearer ${jwt}`},
        data: {}
    })
}

// Get application by id
export function getApplication (applicationId, jwt) {
    return axios({
        method: 'GET',
        url: vars.baseURL + `/api/v2/employment/applications/${applicationId}`,
        headers: { api_key: vars.apiKey, 'X-XSRF-TOKEN': vars.csrfToken, 'Authorization': `Bearer ${jwt}`},
        data: {}
    })
}


// Get applications by company
//searchParams state applicantName position
export function getApplicationsByCompany (companyId, searchParams, jwt) {
    const params = new URLSearchParams(searchParams)
    return axios({
        method: 'GET',
        url: vars.baseURL + `/api/v2/employment/companies/${companyId}/applications?` + params,
        headers: { api_key: vars.apiKey, 'X-XSRF-TOKEN': vars.csrfToken, 'Authorization': `Bearer ${jwt}`},
        data: {}
    })
}

// Get applications by student
export function getApplicationsByStudent (sort, jwt) {
    return axios({
        method: 'POST',
        url: vars.baseURL + `/api/v3/employment/GetStudentApplications`,
        headers: { api_key: vars.apiKey, 'X-XSRF-TOKEN': vars.csrfToken, 'Authorization': `Bearer ${jwt}`},
        data: {
            sort: sort
        }
    })
}


// data = {
    // company: String
    // fullTime: Bool
    // location: [“Remote”, Name_of_City]
    // compensationType: [ “Hourly” | “Salary” | “Commission” | “Contract” ]
    // compensation: Double
    // description: String
    // requirements: String
    // qualification: String
    // benefits: String
    // }
export function createJob (data, jwt){
    return axios({
        method: 'POST',
        url: vars.baseURL + '/api/v2/employment/jobs',
        headers: { api_key: vars.apiKey, 'X-XSRF-TOKEN': vars.csrfToken, 'Authorization': `Bearer ${jwt}`},
        data: data
    })
  }

//   data = {
//   name: String,
//   description: String,
//   message: String,
//   logo: String,
//   mission: String,
//   yearFounded: String,
//   employmeeCount: Integer,
//   city: String,
//   state: String,
//   country: String,
//   website: String
//   }
  export function createCompany (data, jwt){
    return axios({
        method: 'POST',
        url: vars.baseURL + '/api/v2/employment/companies',
        headers: { api_key: vars.apiKey, 'X-XSRF-TOKEN': vars.csrfToken, 'Authorization': `Bearer ${jwt}`},
        data: data
    })
  }

//   data = {
//     applicant: BigInt
//     company: BigInt
//     jobPosting: BigInt
//     questionResponses: [
//     { question: String, mediaType: String, response: String },
//     { question: String, mediaType: String, response: String },
//     { question: String, mediaType: String, response: String },
//     ]
// }
export function submitApplication (data, jobId, jwt) {
    return axios({
        method: 'POST',
        url: vars.baseURL + `/api/v2/employment/jobs/${jobId}/applications`,
        headers: { api_key: vars.apiKey, 'X-XSRF-TOKEN': vars.csrfToken, 'Authorization': `Bearer ${jwt}`},
        data: data
    })
}

//   data = {
//   name: "Twitter",
//   description: "A news and social media platform. We let you know what's happening",
//   message: "",
//   logo: "",
//   mission: "A news and social media platform. We let you know what's happening",
//   yearFounded: 2000,
//   employeeCount: 200,
//   city: "San Francisco",
//   state: "California",
//   country: "USA",
//   website: "www.twitter.com"
//   }

//   data = {
//     fullTime: Bool
//     location: [“Remote”, Name_of_City]
//     compensationType: [ “Hourly” | “Salary” | “Commission” | “Contract” ]
//     compensation: Double
//     description: String
//     requirements: String
//     qualification: String
//     benefits: String
//     }
export function updateJob (jobId, data, jwt) {
    return axios({
        method: 'PATCH',
        url: vars.baseURL + `/api/v2/employment/jobs/${jobId}`,
        headers: { api_key: vars.apiKey, 'X-XSRF-TOKEN': vars.csrfToken, 'Authorization': `Bearer ${jwt}`},
        data : data
    })
}

// data = {
// employer: String
// application: String
// date: YYYY-MM-DD
// time: hh:mm
// notes: String,
// date: String (yyyy-mm-dd),
// time: String (hh:mm)
// }
export function requestInterview (data, jwt){
    return axios({
        method: 'POST',
        url: vars.baseURL + '/api/v2/employment/interviews',
        headers: { api_key: vars.apiKey, 'X-XSRF-TOKEN': vars.csrfToken, 'Authorization': `Bearer ${jwt}`},
        data: data
    })
}

// data = {
//     date: YYYY-MM-DD
//     time: hh:mm
//     status: [“Scheduled”, “OnGoing”, “Completed”, “Canceled”]
//     notes: String
//     date: String (yyyy-mm-dd),
//     time: String (hh:mm)
// }
export function updateInterview (interviewId, data, jwt){
    return axios({
        method: 'PATCH',
        url: vars.baseURL + `/api/v2/employment/interviews/${interviewId}`,
        headers: { api_key: vars.apiKey, 'X-XSRF-TOKEN': vars.csrfToken, 'Authorization': `Bearer ${jwt}`},
        data: data
    })
}

// data = {
// state: [“New”, “Pending”, “Considered”, “Interviewing”, “Reviewing”, “Hired”, “Rejected”]
// note: String
// }
export function updateApplication (jobId, applicationId, data, jwt) {
    return axios({
        method: 'PATCH',
        url: vars.baseURL + `/api/v2/employment/jobs/${jobId}/applications/${applicationId}`,
        headers: { api_key: vars.apiKey, 'X-XSRF-TOKEN': vars.csrfToken, 'Authorization': `Bearer ${jwt}`},
        data : data
    })
}

export function getDiscoveryJobs (userId, jwt) {
    const params = new URLSearchParams({userId: userId})
    return axios({
        method: 'GET',
        url: vars.baseURL + `/api/v2/discovery/jobs?` + params,
        headers: { api_key: vars.apiKey, 'X-XSRF-TOKEN': vars.csrfToken, 'Authorization': `Bearer ${jwt}`},
        data: {}
    })
}

// Param(s): userId: (Optional) BigInteger, companyId: (Optional) String
export function getInterviews (searchParams, jwt) {
    const params = new URLSearchParams(searchParams)
    return axios({
        method: 'GET',
        url: vars.baseURL + `/api/v2/employment/interviews?` + params,
        headers: { api_key: vars.apiKey, 'X-XSRF-TOKEN': vars.csrfToken, 'Authorization': `Bearer ${jwt}`},
        data: {}
    })
}

export function joinInterview (interviewId, jwt) {
    return axios({
        method: 'GET',
        url: vars.baseURL + `/api/v2/employment/JoinInterview`,
        headers: { api_key: vars.apiKey, 'X-XSRF-TOKEN': vars.csrfToken, 'Authorization': `Bearer ${jwt}`},
        data: {
            interviewId: interviewId
        }
    })
}

export function getJobTypes (jwt) {
    return axios({
        method: 'OPTIONS',
        url: vars.baseURL + `/api/v2/employment/jobs/types`,
        headers: { api_key: vars.apiKey, 'X-XSRF-TOKEN': vars.csrfToken, 'Authorization': `Bearer ${jwt}`},
        data: {}
    })
}

export function getJobSubTypes (type, jwt) {
    return axios({
        method: 'OPTIONS',
        url: vars.baseURL + `/api/v2/employment/jobs/types/${type}/subtypes`,
        headers: { api_key: vars.apiKey, 'X-XSRF-TOKEN': vars.csrfToken, 'Authorization': `Bearer ${jwt}`},
        data: {}
    })
}

//{userId, companyId}
export function getUserContracts (studentUserName, jwt) {
    return axios({
        method: 'GET',
        url: vars.baseURL + `/api/v2/employment/FetchContractsWithStudent`,
        headers: { api_key: vars.apiKey, 'X-XSRF-TOKEN': vars.csrfToken, 'Authorization': `Bearer ${jwt}`},
        data: {
            studentUserName
        }
    })
}

export function completeContract (contractId, jwt){
    return axios({
        method: 'PATCH',
        url: vars.baseURL + `/api/v2/employment/contracts/${contractId}`,
        headers: { api_key: vars.apiKey, 'X-XSRF-TOKEN': vars.csrfToken, 'Authorization': `Bearer ${jwt}`},
        data: {state: "COMPLETED"}
    })
}

// data = {reviewerId: BigInt, review: String, rating Double}
export function submitReviewByContract (contractId, data, jwt) {
    return axios({
        method: 'PUT',
        url: vars.baseURL + `/api/v2/employment/contracts/${contractId}/reviews`,
        headers: { api_key: vars.apiKey, 'X-XSRF-TOKEN': vars.csrfToken, 'Authorization': `Bearer ${jwt}`},
        data: data
    })
}

export function getReviewsByContractor (contractorId, jwt) {
    return axios({
        method: 'GET',
        url: vars.baseURL + `/api/v2/employment/contractors/${contractorId}/reviews`,
        headers: { api_key: vars.apiKey, 'X-XSRF-TOKEN': vars.csrfToken, 'Authorization': `Bearer ${jwt}`},
        data: {}
    })
}
